import InlineHelp from "./InlineHelp.vue";
import { pluginify } from "./../../util";
export default pluginify(InlineHelp);
export { InlineHelp };
